import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
import { MovieTicketConfirmation, MovieTicketPayment, TxPinVerification } from "src/component"
import MovieImg from 'src/assets/img/movie-img2.svg'
import { BsCalendar2EventFill } from "react-icons/bs"
import { IoTime } from "react-icons/io5"
import { MdLocalMovies } from "react-icons/md"
import { AiFillStar } from "react-icons/ai"

export const MovieDetails: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({movieDateTime: '', accountNo: ''})
    const [view, setView] = useState('movie-details')

    function handleInput (name: string, data: string) {
        setInput({...input, [name]: data})
    }

    async function handleNext() {
        setView('ticket-payment')
    }

    async function handleSubmit() {
        notifier.show('Movie Booked', null, 'success')
        close()
    }

    return (
        <>
            { view === 'movie-details' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Movie Details</ScreenTitle>
                    <CustomContainer topMargin="2">
                        <GridContainer>
                            <CustomContainer 
                                width="30.5" height="38.91" radius="1.16" bottomMargin="2"
                                className="movie-details-img-wrapper"
                            >
                                <Icon src={MovieImg} minWidth='100' noResize style={{objectFit: 'cover'}}  />
                            </CustomContainer>
                            <AppSpan textSize="2.4" fontWeight="700" color="#111111" fontFamily="Gilmer-Bold">Oceans 8</AppSpan>
                            <FlexRow 
                                gap="2" topMargin="1.7" justifyContent="space-between" width="30.5"
                                className="movie-period-flex" wrap="wrap"
                            >
                                <FlexRow width="auto" sizeUnit="">
                                    <BsCalendar2EventFill style={{fontSize: '1.2rem', marginRight: '0.7rem', color: '#434E58'}} />
                                    <AppSpan textSize="1.2" color="#78828A">17 Sep 2021</AppSpan>
                                </FlexRow>
                                <FlexRow width="auto" sizeUnit="">
                                    <IoTime style={{fontSize: '1.5rem', marginRight: '0.7rem', color: '#434E58'}} />
                                    <AppSpan textSize="1.2" color="#78828A">148 Minutes</AppSpan>
                                </FlexRow>
                                <FlexRow width="auto" sizeUnit="">
                                    <MdLocalMovies style={{fontSize: '1.5rem', marginRight: '0.7rem', color: '#434E58'}} />
                                    <AppSpan textSize="1.2" color="#78828A">Action</AppSpan>
                                </FlexRow>
                            </FlexRow>
                            <FlexRow width="auto" sizeUnit="" gap="0.6" topMargin="1.5">
                                {
                                    Array.from(Array(5).keys()).map((item: number) => {
                                        let rating = 4
                                        let color = rating-1 >= item ? '#FACC15': '#78828A'
                                        return (
                                            <AiFillStar style={{color, fontSize: '1.7rem'}} />
                                        )
                                    })
                                }
                            </FlexRow>
                        </GridContainer>
                        <CustomContainer topMargin="3">
                            <AppSpan textSize="1.6" fontWeight="600" color="#111111" >Story Line</AppSpan>
                            <AppText color="#78828A" topMargin="1.7">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since 
                            </AppText>
                        </CustomContainer>
                        <FlexRow justifyContent="flex-end" topMargin='2'>
                            <Button 
                                width='11' height='4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                onClick={handleNext}
                            >
                                Buy Ticket
                            </Button>
                        </FlexRow>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit}
                />
            }
            { view === 'ticket-payment' &&
                <MovieTicketPayment
                    close={close}
                    next={() => setView('movie-ticket-confirmation')}
                    handleInput={handleInput}
                    input={input}
                    back={() => setView('movie-details')}
                />
            }
            { view === 'movie-ticket-confirmation' &&
                <MovieTicketConfirmation
                    close={close}
                    next={() => setView('pin')}
                    back={() => setView('ticket-payment')}
                />
            }
        </>
    )
}